// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__Ilsfh","checkbox2":"checkbox_checkbox2__vIivw","ecommerceCheckboxPrimary":"checkbox_ecommerceCheckboxPrimary__ply0R"};